import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

const UnsavedChangesDialog = ({ open, onCancel, onDiscard }: UnsavedChangesDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="unsaved-changes-title"
    aria-describedby="unsaved-changes-description"
  >
    <DialogTitle id="unsaved-changes-title">Óvistaðar breytingar</DialogTitle>
    <DialogContent>
      <DialogContentText id="unsaved-changes-description">
        Breytingarnar hafa ekki verið vistaðar. Viltu loka glugganum og fleygja þeim?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} autoFocus>Halda áfram að breyta</Button>
      <Button onClick={onDiscard} color="error">Loka án þess að vista</Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
